import { colors, mediaQueries, hbuiGlobalStyles, vars } from '@honeybook/hbui';
import { createGlobalStyle } from 'styled-components';
import getConfig from 'next/config';
import 'react-datepicker/dist/react-datepicker.css';

export const GlobalStyles = createGlobalStyle`
    ${hbuiGlobalStyles}

    :root {
        --mobile-gutters: 8px;
        --mobile-bar-height: 60px;
        --top-margin: 32px;
        --topbar-height: ${getConfig().publicRuntimeConfig.hasStickyHeader ? '0px' : '50px'};
        --default-padding: 16px;
        --top-buffer: ${getConfig().publicRuntimeConfig.hasStickyHeader ? '0px' : 'calc(100px + 75px)'};
        --sidenav-width: 0;
    }

    body {
        margin: 0;
        width: calc(100% - var(--sidenav-width));
        font-family: ${vars.fonts.body};
        color: ${colors.neutral900};
        min-height: calc(100vh - var(--top-buffer) - var(--top-margin));
        margin-block-start: calc(var(--top-buffer) + var(--top-margin));
        height: 100%;

        &[sidenav-state='collapsed'], &[sidenav-state='collapsed'][data-scroll-locked] {
            --sidenav-width: 56px;
            margin-inline-start: var(--sidenav-width);

            // override body-scroll-lock padding from hbui
            padding-left: 0;
        }


        &[sidenav-state='pinned'], &[sidenav-state='pinned'][data-scroll-locked] {
            --sidenav-width: 240px;
            margin-inline-start: var(--sidenav-width);

            // override body-scroll-lock padding from hbui
            padding-left: 0;
        }

        &.no-scroll {
            overflow: hidden;
        }

        &:has([role='dialog']) {
            overflow: hidden;
        }

        &:has(.fullscreen) {
            margin: 0;
            width: 100%;
        }
        
        ${mediaQueries.upToMedium} { // no side nav on mobile web
            width: 100%;
            margin-inline-start:0 !important;
            margin-block-start: var(--topbar-height);
            &[sidenav-state='collapsed'], &[sidenav-state='collapsed'][data-scroll-locked] {
                margin-inline-start: 0;
            }
        }


        ${mediaQueries.mediumUp} {
            scroll-padding-bottom: 80px;
        }
    }

    
    main {
        padding: 0 30px 40px;
        ${mediaQueries.upToMedium} {
            height: calc(100vh - var(--topbar-height));
        }
        ${mediaQueries.xLargeUp} {
            padding: 0 0 40px;
        }
    }
    
    p, h1, h2, h3, h4, h5, h6 {
        margin: 0;
        padding: 0;
    }
    
    a {
        color: inherit;
        text-decoration: none;
    }

    * {
        box-sizing: border-box;

        &:focus {
            outline: none;
        }
    }

    button {
        font-family: ${vars.fonts.body};
        border: 0;
    }
`;
